'use client'

import DashboardShell from './components/DashboardShell';
import CaseSearchPanel from './components/CaseSearchPanel';

export default function CaseSearchPage() {
  return (
    <DashboardShell>
      <div className="mx-auto max-w-5xl">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Case Search</h1>
          <p className="mt-1 text-sm text-gray-600">
            Search active or archived cases by any debtor name or part of a case number.
          </p>
        </div>

        <CaseSearchPanel autoFocus />
      </div>
    </DashboardShell>
  );
}
